import { useMutation, useQueryClient } from "react-query";

import { documentTemplateService } from "@services/document-templates-service";
import { documentTemplatesQueryKeys } from "./queryKeys";
import { DeleteDocumentTemplatesGroupData } from "@interfaces/company/document-templates";

export const useDeleteDocumentTemplatesGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DeleteDocumentTemplatesGroupData) =>
      documentTemplateService.deleteGroup(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
